<template>
  <div class="customCenter" style="z-index:999;">
    <!--Normal-->
    <div v-if="$vuetify.breakpoint.smAndUp" class="ma-0 pa-0">
      <!--Logged in-->
      <div v-if="isLoggedIn == true" class="ma-0 pa-0">
        <!--Frontpage-->
        <div v-if="isUserPage == false" class="ma-0 pa-0">
          <v-row class="ma-0 pa-0">
            <!--Logo-->
            <v-col class="ma-0 pa-0 left">
              <router-link to="/front">
                <img src="/welong.svg" alt="wenewz logo" style="width: 150px"/>
              </router-link>
            </v-col>
            <!--Notification and profile-->
            <v-col class="ma-0 pa-0 text-end">
              <Notification></Notification>
              <ProfileSelector></ProfileSelector>
              <!---If ADMIN - Need to be fixed-->
              <!-- <AdminSelector></AdminSelector> -->
            </v-col>
          </v-row>
        </div>
        <!--User Page-->
        <div v-else class="ma-0 pa-0">
          <v-row class="ma-0 pa-0">
            <!--Logo-->
            <v-col class="ma-0 pa-0 left ">
              <router-link to="/front">
                <img src="/welong.svg" alt="wenewz logo" style="width: 150px"/>
              </router-link>
            </v-col>
            <!--To frontpage button - May not be needed-->
            <v-col class="ma-0 pa-0 text-end">
              <v-btn to="/" v-if="$vuetify.breakpoint.smAndUp">Frontpage</v-btn>
            </v-col>
          </v-row>
        </div>
      </div>



      <!--Not Logged in-->
      <div v-else class="ma-0 pa-0">
        <v-row class="ma-0 pa-0">
          <!--Logo-->
          <v-col class="ma-0 pa-0 left">
            <router-link to="/front">
              <img src="/welong.svg" alt="wenewz logo" style="width: 150px"/>
            </router-link>
          </v-col>
          <!--Login and Logout-->
          <v-col class="ma-0 pa-0 text-end">
            <span><v-btn text to="/login">{{$t('navbar.general.Login')}}</v-btn></span>
            <span> / </span>
            <span><v-btn text to="/register">{{$t('navbar.general.Sign up')}}</v-btn></span>
          </v-col>
        </v-row>
      </div>
    </div>


    <!--Phone-->
    <div v-else class="ma-0 pa-0">
      <!--Logged in-->
      <div v-if="isLoggedIn == true" class="ma-0 pa-0">
        <!--FrontPage-->
        <div v-if="isUserPage == false">
          <v-row class="ma-0 pa-0">
            <!--Logo-->
            <v-col class="ma-0 pa-0 left pt-2">
              <router-link to="/front">
                <img src="/welong.svg" alt="wenewz logo" style="width: 70px" />
              </router-link>
            </v-col>
            <!--Profil + Notification-->
            <v-col class="ma-0 pa-0 text-end pr-6" >
              <SidebarRight></SidebarRight>
            </v-col>
          </v-row>
        </div>
        <!--UserPage-->
        <div v-else>
          <v-row class="ma-0 pa-0 ">
            <!--Logo-->
            <v-col class="ma-0 pa-0 left pt-2">
              <router-link to="/front">
                <img src="/welong.svg" alt="wenewz logo" style="width: 70px" />
              </router-link>
            </v-col>
            <!--Navigation Drawer-->
            <v-col class="ma-0 pa-0 text-end">
              <SidebarRight></SidebarRight>
            </v-col>
          </v-row>
        </div>
      </div>
      <!--Not Logged in-->
      <div v-else>
        <v-row class="ma-0 pa-0">
          <!--Logo-->
          <v-col class="ma-0 pa-0 left pt-2">
            <router-link to="/front">
              <img src="/wenewz_middle_2color.svg" alt="wenewz logo"  style="width: 70px" />
            </router-link>
          </v-col>
          <!--Navigation Drawer-->
          <v-col class="ma-0 pa-0 pr-6 text-end">
            <SidebarRight></SidebarRight>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import messages from "../modules/lang/export";
import ArticleTabs from "@/components/navbar/components/articleTabs.vue";
import NavbarRightBig from "@/components/navbar/components/LayoutRightSide.vue";
import NavbarBig from "@/components/navbar/navbarBig.vue";
import Notification from "@/components/navbar/components/notification.vue";
import ProfileSelector from "@/components/navbar/components/profile_selection.vue";
import LanguageSelector from "@/components/navbar/components/language_selector.vue";
import SidebarRight from "@/components/navbar/sidebarRight.vue";
import AdminSelector from "@/components/navbar/components/admin_selection.vue"
export default {
  name: "App",
  i18n: { messages },
  components: {
    NavbarBig,
    NavbarRightBig,
    Notification,
    ProfileSelector,
    LanguageSelector,
    ArticleTabs,
    SidebarRight,
    AdminSelector
  },
  data() {
    return {
      //
      scrolled: false,
      currentItem: '',
      tabItems: [
        'Front Page','Web', 'Shopping', 'Videos', 'Images', 'My EPIC STUFF', 'TEST TEST TEAST', 'QWERTTYYY', 'ABCDE FGHIJKL', 'NEI HAR DU SETT'
      ],
    };
  },
  computed: {
    ...mapGetters(["isLoggedIn", "authStatus", "fullName", "updateStatus", "getLang"]),
    isLogin() {
      return this.$route.name ==='login' 
      || this.$route.name ==='register'
    },
    isUserPage() {
      return this.$route.name ==='listarticles' 
      // || this.$route.name =='dashboard' 
      || this.$route.name ==='editprofile' 
      || this.$route.name ==='createarticle' 
      || this.$route.name ==='profilesettings' 
      || this.$route.name ==='editfrontpagesettings'
      || this.$route.name ==='inbox'
      || this.$route.name ==='follows'
      || this.$route.name ==='managefeeds'
      || this.$route.name ==='editarticle'
    }
  },
  mounted() {
    if (this.isLoggedIn && this.authStatus == "") {
      this.$store
        .dispatch("loginWithToken")
        .then(resp => {
          // setTimeout(() => this.$router.push("/"), 600);
        })
        .catch(err => {
          console.log(err);
        }
      );
    }
  },
  watch: {
    getLang(newLocale) {
      this.selectedlanguage = newLocale;
    }
  },
  methods: {
    handleScroll () {
      this.scrolled = window.scrollY > 0;
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll);
  }
};
</script>

<style scoped>

.customCenter {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  /* justify-content: space-between; */
  align-content: stretch;
  align-items: flex-start;
}
.customCenter > * {
  width: 100%;
  margin-bottom: 20px;
}


.customCenter .left {
  order: 0;
  flex: 0  ;
  width:5%;
  min-width:5%;
  align-self: auto;
  text-align: left;
}

.customCenter .centertwo{
  /* margin: 15px; */
  
  order: 1;
  display:flex;
  /* flex: 0 1 auto; */
  /* align-self: auto; */
  text-align: center;
  justify-content:center;
  /* border:solid black 1px; */
  width:75%;
  min-width:75%;
  color:transparent;
}
.customCenter .centertwo{
  /* margin: 15px; */
  
  order: 1;
  display:flex;
  /* flex: 0 1 auto; */
  /* align-self: auto; */
  text-align: center;
  justify-content:center;
  /* border:solid black 1px; */
  width:75%;
  min-width:75%;
  color:transparent;
}

.customCenter .center {
  /* margin: 15px; */
  
  order: 1;
  display:flex;
  /* flex: 0 1 auto; */
  /* align-self: auto; */
  text-align: center;
  justify-content:center;
  /* border:solid black 1px; */
  width:60%;
  min-width:60%;
  max-width:60%;
  color:transparent;
}

.customCenter .right {
  /* margin: 15px; */
  order: 2;
  display:flex;
  /* flex: 0 1 auto; */
  /* align-self: auto; */
  padding-right:5em;
  text-align: right;
  align-self:flex-end;
  align-items:flex-end;
  align-content:flex-end;
  align-self:end;
  align-items:end;
  align-content:end;
  justify-self:flex-end;
  justify-content:flex-end;
  justify-items:end;
  justify-self:end;
  justify-content:end;
}

/*Image for the center Big Navbar*/
.customCenter .center img {
  width: 150px;
}
/*Image for the left Small Navbar*/
.customCenter .left img {
  width: 150px;
}

.customCenter .right a, a.articlelinks {
  text-decoration: none;
  color: black;
}
.customCenter .right a:hover,
a.articlelinks:hover {
  text-decoration: underline;
}
.topbar-menu-container {
  border-bottom: 4px solid black;
  padding-bottom: 20px;
}
.topbar-menu-container .flex {
  text-align: center;
  /* font-size: 1.2em; */
}
/* .usynlegbakgrunn {
  background-color: transparent !important;
} */

/* h1,
h2,
h3 {
  font-family: "Montserrat", sans-serif;
} */
</style>
